import { toast } from "react-toastify";
import { UndoToast } from "../components/UndoToast";

const UNDO_TOAST_MS = 8000;

// The dark "… · Undo" message at the bottom of the screen that a team-wide
// action leaves for about 8 seconds (Clear flag, No reply needed).
export const showUndoToast = (message: string, onUndo: () => void) =>
  toast(
    ({ closeToast }) => (
      <UndoToast message={message} onUndo={onUndo} closeToast={closeToast} />
    ),
    {
      autoClose: UNDO_TOAST_MS,
      closeOnClick: false,
      icon: false,
      theme: "dark",
      className:
        "!mx-auto !min-h-0 !w-fit !rounded-lg !bg-alpha-800 !px-4 !py-2.5 shadow-lg",
      bodyClassName: "!m-0 !p-0"
    }
  );
